import React, { FunctionComponent, useEffect } from 'react'
import Modal from 'react-modal'

const style = require('./Modal.css')

interface Props {
  showModal: Boolean,
  onClose: () => void,
  customClass?: React.CSSProperties,
  bodyOpenClassName?: React.CSSProperties,
  customOverlayClass?: React.CSSProperties,
  children: React.ReactNode;
}

export const ModalComponent: FunctionComponent<Props> = ({
  showModal,
  onClose,
  customClass,
  bodyOpenClassName,
  customOverlayClass,
  children,
}) => {
  useEffect(() => (typeof window !== 'undefined') && Modal.setAppElement('body'), [])

  return (
    <Modal
      contentLabel="Modal"
      overlayClassName={`${style.overlay} ${customOverlayClass}`}
      isOpen={showModal}
      onRequestClose={onClose}
      className={customClass || style.base}
      bodyOpenClassName={bodyOpenClassName || null}
    >
      {children}
    </Modal>
  )
}
